import Button from "@material-ui/core/Button"
import Badge from '@material-ui/core/Badge'
import React, { useState, useEffect } from 'react'; 
import ClearIcon from '@material-ui/icons/Clear';
import { green } from '@material-ui/core/colors';
import { Tooltip } from "@material-ui/core";
import DoneAllIcon from '@material-ui/icons/DoneAll';
import { ApplicationState } from '../store';
import { useSelector } from 'react-redux';

export type ConnectionButtonProps = {
    /** whether the button is currently in the 'connected' */
    connected?: boolean
    /** flag to use when showing disconnect button. */
    openOnConnect?: boolean
    /** flag to determine to open modem portal on connect */
    showDisconnect?: boolean
    /** action to run on connection */
    onConnect?: () => void
    connectLabel?: string
    /** action to run on disconnection */
    onDisconnect?: () => void
    disconnectLabel?: string
    /** whether the button should be medium or small */
    large?: boolean
    /** local IP of Modem or nECY */
    localIp?: string
    disabled?: boolean
}

export default function ConnectionButton(props: ConnectionButtonProps) {

    const protocol = "https://"
    const isLoadingModem = useSelector<ApplicationState, boolean | undefined>(state => state.modems?.isLoading);
    //flag to determine to open page on callback.
    const [openUrl, setOpenUrl] = React.useState<boolean>(false);

    useEffect(() => {
        if (props.openOnConnect && openUrl && !isLoadingModem && props.localIp) {
            window.open(protocol + props.localIp)
            setOpenUrl(false);
        }
    });
    function handleConnect() {
        if (!props.connected && props.onConnect) {
            props.onConnect();
            if (props.openOnConnect) {
                setOpenUrl(true);
            }
        } else {
            if (props.openOnConnect) {
                window.open(protocol + props.localIp)
            }
        }
    }
    return (
        ((props.connected?? true ) && (props.showDisconnect ?? true))
            ?<Button variant='contained' color='primary' size={props.large ? 'medium' : 'small'}
                    onMouseEnter={e => /** change the hover actions for the buttons. TODO: This does not work currently */
                        e.currentTarget.classList.replace('btn-success', 'btn-warning')}
                    onMouseOut={e => e.currentTarget.classList.replace('btn-warning', 'btn-success')}
                    onClick={props.onDisconnect}>{props.connectLabel ?? "Disconnect"}</Button>
            :
            <Button variant='contained' color='primary' disabled={props.disabled} size={props.large ? 'medium' : 'small'}
                onMouseEnter={e => e.currentTarget.classList.replace('btn-dark', 'btn-success')}
                onMouseOut={e => e.currentTarget.classList.replace('btn-success', 'btn-dark')}
                onClick={handleConnect}>{props.connectLabel ?? "Connect"}</Button>
    )
}
